/* Wall-art PDP runtime: mobile sticky Add-to-Cart bar + first-order offer.
 *
 * Two independent features, both opt-in via markup that main-product.liquid
 * renders:
 *
 *   A. Offer banner ("Get 10% off your first order!" → "Get Your Code")
 *      The button opens the welcome email-capture popup on demand via the
 *      global that email-capture-popup.js exposes (window.YukiEmailPopup).
 *      If that popup feature is switched off in the theme editor (so the
 *      global never appears), the banner hides itself rather than leave a
 *      button that does nothing.
 *
 *   B. Mobile sticky ATC bar (CSS gates it to < 750px).
 *      Mirrors the live price (#price-<section>) and proxies the REAL
 *      Add-to-Cart button — we never bypass the wall-art picker's
 *      pre-submit logic, we just forward a click to it. The bar appears
 *      only once the inline buy button has been scrolled *past* (above the
 *      viewport), matching the desktop "scroll past, then it sticks" feel.
 *
 * Defensive throughout: every feature no-ops if its anchor isn't on the
 * page (e.g. Wall Set products render their own ATC and have no
 * .product-form__submit, so the sticky bar simply doesn't build). */
(function () {
  if (window.__waPdpEnhanceInit) return;
  window.__waPdpEnhanceInit = true;

  function popupAvailable() {
    return !!(window.YukiEmailPopup && typeof window.YukiEmailPopup.open === 'function');
  }

  function wireOfferBanner() {
    var triggers = document.querySelectorAll('[data-wa-offer-trigger]');
    if (!triggers.length) return;
    triggers.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (popupAvailable()) window.YukiEmailPopup.open();
      });
    });
    // If the welcome popup feature is disabled, there's nothing to open —
    // hide the banner so we never show a dead button. Check after full load
    // because email-capture-popup.js (footer-group) runs after this script.
    window.addEventListener('load', function () {
      if (popupAvailable()) return;
      document.querySelectorAll('[data-wa-offer]').forEach(function (el) {
        el.style.display = 'none';
      });
    });
  }

  function buildStickyAtc() {
    var info = document.querySelector('.product__info-container');
    if (!info) return;

    var submitBtn = info.querySelector('.product-form__submit');
    if (!submitBtn) return; // Wall Set / no buy-button → no sticky bar.
    var priceEl = info.querySelector('[id^="price-"]');

    var bar = document.createElement('div');
    bar.className = 'wa-sticky-atc';
    bar.setAttribute('data-wa-sticky-atc', '');

    var priceSlot = document.createElement('div');
    priceSlot.className = 'price wa-sticky-atc__price';

    var barBtn = document.createElement('button');
    barBtn.type = 'button';
    barBtn.className = 'wa-sticky-atc__btn';

    bar.appendChild(priceSlot);
    bar.appendChild(barBtn);
    document.body.appendChild(bar);

    function syncPrice() {
      if (priceEl) priceSlot.innerHTML = priceEl.innerHTML;
    }
    function syncButton() {
      var label = submitBtn.querySelector('span');
      barBtn.textContent = (label ? label.textContent : submitBtn.textContent || 'Add to cart').trim();
      barBtn.disabled = submitBtn.disabled;
    }
    syncPrice();
    syncButton();

    // Forward to the real submit button → runs product-form.js + the
    // wall-art picker's variant write. Never bypassed.
    barBtn.addEventListener('click', function () {
      if (submitBtn.disabled) return;
      submitBtn.click();
    });

    if (typeof MutationObserver !== 'undefined') {
      if (priceEl) {
        new MutationObserver(syncPrice).observe(priceEl, {
          childList: true, subtree: true, characterData: true,
        });
      }
      new MutationObserver(syncButton).observe(submitBtn, {
        attributes: true, attributeFilter: ['disabled', 'class'], childList: true, subtree: true,
      });
    }

    // Show the bar only when the inline ATC is ABOVE the viewport (scrolled
    // past) — not while it's still below the fold and not yet reached.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', scrolledPast);
      }, { threshold: 0 });
      io.observe(submitBtn);
    }
  }

  function init() {
    wireOfferBanner();
    buildStickyAtc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
